import { useEffect, useMemo, useState } from 'react'
import { createPortal } from 'react-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  switchToSaleSession,
  enableMexicoMode,
} from '../../state/salesSessionThunks'
import { useLabels } from '../../functions'
import { WindowStack } from '../Icons'
import { ensureActiveCaseSession } from '../../state/salesSessionThunks'

import { setEmbeddedShowNewCase } from '../../state/embeddedSlice'

import { resetSlicesForNewCase } from '../../state/salesSessionThunks'
import { useIsMexico } from '../../functions'

export default function MultiSessionSalesBar() {
  const dispatch = useDispatch()
  const { order, byId, enabled } = useSelector(s => s.salesSessions)
  const caseId = useSelector(s => s.customer?.data?.caseId)
  const isMX = useIsMexico();
  const [shouldShowButton, setShouldShowButton] = useState(false);


  const inboxItems = useSelector(s => s.chatInbox?.items || {})

  const inboxCount = useMemo(() => {
    let count = 0
    for (const id in inboxItems) {
      const st = inboxItems[id]?.status
      if (st === 'new' || st === 'staged') count++
    }
    return count
  }, [inboxItems])

  const itemsArray = useMemo(() => {
    return Object.values(inboxItems)
      .sort((a, b) => (b?.receivedAt ?? 0) - (a?.receivedAt ?? 0))
  }, [inboxItems])

  //const showButton = (enabled && itemsArray.length > 1) || showButton
  const [open, setOpen] = useState(false)
  const [tab, setTab] = useState('new')
  const labels = useLabels()

  

  const filteredChats = useMemo(() => {
    if (tab === 'all') return itemsArray
    return itemsArray.filter(x => x.status === tab)
  }, [itemsArray, tab])

  const counts = useMemo(() => {
    const c = { new: 0, staged: 0, opened: 0, all: itemsArray.length }
    for (const it of itemsArray) {
      if (it.status === 'new') c.new++
      if (it.status === 'opened') c.opened++
    }
    return c
  }, [itemsArray])


  useEffect(() => {
    if (caseId && isMX ) dispatch(ensureActiveCaseSession());
  }, [caseId,isMX,dispatch]);

  useEffect(() =>{
    dispatch(enableMexicoMode());
  },[itemsArray,dispatch])

  useEffect(() => {
    if (enabled && itemsArray.length > 1) {
      setShouldShowButton(true); 
    } else if (itemsArray.length === 0) {
      setShouldShowButton(false); 
    }
  }, [enabled, itemsArray.length]);

  useEffect(() => {
    if (!open) return
    const onKey = (e) => e.key === 'Escape' && setOpen(false)
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open])


  if (!shouldShowButton ) return null


  const handleGoToCase = (chat) => {
    if (chat.sessionId && byId[chat.sessionId]) {
      dispatch(switchToSaleSession(chat.sessionId))
      setOpen(false)
      return
    }
    const match = Object.values(byId).find(
      m => m?.snapshot?.customer?.data?.caseId === chat.caseId
    )
    if (match?.id) {
      dispatch(switchToSaleSession(match.id))
      setOpen(false)
      dispatch(setEmbeddedShowNewCase(false))
      
      return
    }
  }
  return (
    <>
      <button
        type="button"
        title={`Sale scripts (${order.length}) • Inbox: ${inboxCount}`}
        aria-label="Sale scripts"
        onClick={() => setOpen(true)}
        className="btn  rounded-circle border position-relative p-1"
        style={{
          width: 25,
          height: 25,
          marginLeft: 12,
          background: '#fff',
          color: '#0a9afa',
          borderColor: '#0a9afa'
        }}
      >
        <WindowStack />
        {inboxCount > 0 &&(
          <span
            className="position-absolute rounded-pill text-white fw-bold d-inline-grid"
            style={{
              top: -6,
              right: -6,
              placeItems: 'center',
              minWidth: 16,
              height: 16,
              lineHeight: '16px',
              fontSize: 10,
              background: '#dc3545',
              boxShadow: '0 1px 6px rgba(0,0,0,.2)',
              padding: '0 4px'
            }}
          >
            {inboxCount}
          </span>
        )}
      </button>

      {open && createPortal(
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-grid"
          style={{ placeItems: 'center', background: 'rgba(0,0,0,.4)', zIndex: 9998 }}
          onClick={() => setOpen(false)}
        >
          <div
            className="bg-white p-4 rounded-3 shadow"
            style={{ width: 760, maxWidth: '94vw' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mb-2 small fw-semibold">{labels.caseList}</div>

            <ul className="nav nav-pills mb-3 gap-2">
              {[
                { id: 'new', label: labels.new, count: counts.new },
                { id: 'opened', label: labels.opened, count: counts.opened },
                { id: 'all', label: labels.all, count: counts.all }
              ].map(t => (
                <li className="nav-item" key={t.id}>
                  <button
                    className={`nav-link ${tab === t.id ? 'active' : ''}`}
                    onClick={() => setTab(t.id)}
                  >
                    {t.label}
                    <span className="badge bg-secondary ms-2">{t.count}</span>
                  </button>
                </li>
              ))}
            </ul>

            <div className="d-grid gap-2 mb-4" style={{ maxHeight: 300, overflow: 'auto' }}>
              {filteredChats.map(chat => {
                const number = (
                  chat.displayNumber ??
                  ''
                ).toString().replace(/\D/g, '');

                return (
                  <div
                    key={chat.chatId}
                    className="d-flex justify-content-between align-items-center rounded-3 border p-2 small"
                  >
                    <div className="pe-2">
                      <div className="fw-semibold text-truncate">
                        {chat.caseId ? `Case ${chat.caseId}` : `Chat ${chat.chatId}`}
                      </div>
                      <div className="text-muted">
                        {number ? `. ${labels.number} ${number}` : ''}
                      </div>
                    </div>

                    <div className="d-flex gap-2">
                      {chat.status !== 'opened' ? (
                        <>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={async () => {
                              dispatch(resetSlicesForNewCase({ preserveProgram: true }, 
                                chat?.args));setOpen(false)
                            }}
                          >
                            {labels.openNewCase}
                          </button>
                        </>
                      ) : (
                        <button 
                          className="btn btn-outline-success btn-sm"
                          onClick={() => handleGoToCase(chat)}
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          {labels.goToCase}
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}

              {filteredChats.length === 0 && (
                <div className="border rounded-3 p-3 text-muted small">
                  {labels.noItems}
                </div>
              )}
            </div>


            <div className="d-flex justify-content-end mt-3">
              <button className="btn btn-outline-secondary" onClick={() => setOpen(false)}>{labels.close}</button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  )
}
